import React, { Component } from 'react'
import Loader from '../common/Loader'
import * as Components from './components'
import styled from 'styled-components'
import QuestionsUtils from './utils/QuestionsUtil'

const EntityList = styled.ul`
  width: 100%;
  display: flex;
  align-items: center;
  list-style: none;
  border-bottom: 1px solid #ddd;
  margin: 0;
  li {
    padding: 10px 20px;
    margin-left: 5px;
    color: #555;
    background-color: #f1f1f1;
    border: 1px solid #ddd;
    border-radius: 4px 4px 0 0;
    border-bottom-color: transparent;
    &:hover {
      cursor: pointer;
    }
    &.active {
      background-color: #ddd;
    }
  }
`

const TabLi = styled.li`
  display: flex;
  align-items: center;
  i {
    margin-right: 5px;
  }
`

class Tabs extends Component {
  state = {
    tabs: [],
    activeTab: null,
    loading: true
  }
  componentDidMount() {
    this.setTabs()
  }
  get oc() {
    const { getBusinessByType } = this

    return getBusinessByType('oc')
  }
  get epc() {
    const { getBusinessByType } = this

    return getBusinessByType('epc')
  }
  getBusinessByType = type => {
    const { props: { loan: { businesses } } } = this

    return businesses.find(({ borrowerType }) => borrowerType === type)
  }
  setActiveTab = activeTab => {
    this.setState({ loading: true })

    setTimeout(() => {
      this.setState({ activeTab, loading: false })
    }, 100)

  }
  setTabs = () => {
    let tabs = []
    let guarantors = []
    const { oc, props: { isEligibility } } = this
    
    if (isEligibility) {
      const { epc, oc: { seniorStaff } } = this
      
      tabs.push({ name: oc?.name, type: 'Business' })

      if (Boolean(epc)) {
        tabs.push({ name: epc?.name, type: 'EpcBusiness' })
      }

      if (seniorStaff.length > 0) {
        seniorStaff.forEach(({ name }) => guarantors.push({ name, type: 'SeniorStaff' }))
      }
    }

    oc?.guarantors.forEach(({ name }) =>
      guarantors.unshift({ name, type: isEligibility ? 'Guarantor' : 'Demographics' }))

    guarantors.forEach(guarantor => tabs.push(guarantor))

    const [activeTab] = tabs

    this.setState({ activeTab, tabs, loading: false })
  }
  getEntityStore = () => {
    const {
      state: { activeTab: { name: activeName, type } },
      oc,
      epc
    } = this

    if (type === 'Business') {
      return oc
    } else if (type === 'EpcBusiness') {
      return epc
    } else {
      const { guarantors, seniorStaff } = oc
      const allGuarantors = guarantors.concat(seniorStaff)

      return allGuarantors.find(({ name }) => name === activeName)
    }
  }
  getQuestions = entity => {
    const {
      props: { loan: { categoriesQuestions, flowVariant, cre }, isPaycheckProtection }
    } = this

    return new QuestionsUtils({
      questions: entity.entityQuestions,
      entity,
      categoriesQuestions,
      flowVariant,
      isPaycheckProtection,
      cre
    })
  }
  renderTabs = () => {
    const {
      state: { tabs, activeTab: { name: activeName } },
      setActiveTab
    } = this

    return (
      <EntityList>
        {tabs.map(({ name, type }) => (
          <TabLi key={`tab-${name}`}
            className={activeName === name ? 'active' :''}
            onClick={() => setActiveTab({ name, type })}
          >
            <i className={`icon-${['Business', 'EpcBusiness'].includes(type) ? 'realestate' : 'hiring'}`} />
            {name}
          </TabLi>
        ))}
      </EntityList>
    )
  }
  renderComponent = () => {
    const {
      props: { isEditable },
      state: { activeTab: { type } },
      getEntityStore,
      getQuestions
    } = this
    let componentType = type

    if (type === 'SeniorStaff') {
      componentType = 'Guarantor'
    }
    if (type === 'EpcBusiness') {
      componentType = 'Business'
    }

    const Tag = Components[`${componentType}Questions`]
    const entityStore = getEntityStore()

    return (
      <Tag
        type={type}
        getQuestions={getQuestions}
        entityId={entityStore?.rid}
        isEditable={isEditable}
      />
    )
  }
  render() {
    const {
      renderTabs,
      renderComponent,
      state: { loading, activeTab }
    } = this

    return activeTab && (
      <>
        {renderTabs()}
        {loading ? (
          <Loader number={4} />
        ) : (
          renderComponent()
        )}
      </>
    )
  }
}

export default Tabs
